import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { InvoiceLine } from '../../models/invoice-line';
import { InvoiceLinesService } from '../services/invoice-lines.service';
import { BreadcrumbResolver } from '../../breadcrumb/breadcrumb.resolver';
import { BreadcrumbService } from '../../breadcrumb/breadcrumb.service';

@Injectable()

/**
 * InvoiceLineResolver resolves request to get an invoice line by id
 */
export class InvoiceLineResolver extends BreadcrumbResolver<InvoiceLine>
{
	/**
	 * InvoiceLineResolver constructor
	 *
	 * @param {InvoiceLinesService} invoiceLinesService
	 * @param {BreadcrumbService} breadcrumbService
	 */
	constructor(breadcrumbService: BreadcrumbService, private invoiceLinesService: InvoiceLinesService)
	{
		super(breadcrumbService);
	}

	getData(params): Observable<InvoiceLine>
	{
		return this.invoiceLinesService.getInvoiceLine(params['lineId']);
	}

	getBreadcrumb(data: InvoiceLine): string
	{
		return data.characteristic;
	}
}




// WEBPACK FOOTER //
// ./src/app/invoices/resolvers/invoice-line.resolver.ts